var app = angular.module("leonardo");

var ExportOverviewDialog = function($scope, ngDialog, FilterService, NotificationService, AccountUserService,
                                    AuthDataService, FormErrorsService, PropertyService) {

  $scope.emails = 1;

  $scope.emails_send = [];
  if (AccountUserService.currentAccountUser && AccountUserService.currentAccountUser.user) {
    $scope.emails_send.push(AccountUserService.currentAccountUser.user.email);
  }
  else {
    $scope.emails_send.push(AuthDataService.authData.user.email);
  }

  $scope.filters = $scope.ngDialogData.filters;

  $scope.getNumber = function(num) {
    return new Array(num);
  };

  $scope.emailsError = function() {
    if (!$scope.Form.$submitted) return false;
    else if ($scope.emails_send.length === 0) return true;
    else {
      var error = true;
      angular.forEach($scope.emails_send, function(value){
        if (value)
          error = false;
      });
      return error;
    }
  };

  $scope.generateUrl = function(url, filters) {
    var query = '?';
    angular.forEach(filters, function(value, key) {
      if (value !== null && value !== undefined && value !== '' && value !== 0) {
        if (angular.isArray(value))
          query += key + '=' + value.join(",") + '&';
        else
          query += key + '=' + value + '&';
      }
    });
    query = query.slice(0, -1);
    url += query;
    return url;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.emailsError()) {
      return;
    }
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.filters) {
      $scope.filters.response_email_recipients = $scope.emails_send.join(',');
    }
    else {
      FilterService.setFilter('response_email_recipients', $scope.emails_send.join(','));
    }
    $scope.loading = ngDialog.open({
      template: 'views/templates/dialog/report/loading.html',
      className: 'ngdialog-theme-default dialog-loading',
      showClose: false
    });
    var promise = PropertyService.exportStatistics($scope.filters);

    promise.then(function() {
      $scope.loading.close();
      NotificationService.notify('success', 'An email will be sent to you in a few moments.');
      $scope.closeThisDialog();
    },function(error){
      $scope.loading.close();
    });
  };

};

app.controller('ExportOverviewDialog', ['$scope', 'ngDialog', 'FilterService', 'NotificationService',
  'AccountUserService', 'AuthDataService', 'FormErrorsService', 'PropertyService', ExportOverviewDialog]);